import { render, staticRenderFns } from "./SimpleHeader.vue?vue&type=template&id=374f1d6a&scoped=true&"
import script from "./SimpleHeader.vue?vue&type=script&lang=js&"
export * from "./SimpleHeader.vue?vue&type=script&lang=js&"
import style0 from "./SimpleHeader.vue?vue&type=style&index=0&id=374f1d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374f1d6a",
  null
  
)

export default component.exports